export type DropdownsStateKeys = 'search' | 'menu'

export type DropdownsState = {
    [key in DropdownsStateKeys]: boolean
}
export const useDropdowns = () =>
    useState<DropdownsState>('dropdowns', () => {
        return {
            search: false,
            menu: false,
        }
    })
